import React from "react";

// Import
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { v4 as uuid } from "uuid";

// Import for Display
import LoginLogoutButton from "./LoginLogoutButton";
import { renderCollection } from "../util/renderCollection";
import { usePullData } from "../hooks/usePullData";

function Navbar() {
  // Accessing data.
  const { data } = useSelector((state) => state.cms);
  const { user } = useSelector((state) => state.auth);
  const singleTypeSlug = "navbar";
  const navData = data[singleTypeSlug] && data[singleTypeSlug].attributes;

  const collectionSlug = "resources";
  const collectionData = data[collectionSlug];

  // Only load if data has returned.
  if (!navData) return null;
  if (!collectionData) return null;

  return (
    <div data-animation="default" data-collapse="medium" data-duration={400} data-easing="ease" data-easing2="ease" role="banner" className="navbar w-nav">
      <div className="w-container">
        <Link to="/" aria-current="page" className="w-nav-brand w--current">
          <img src={navData.logo.data && navData.logo.data.attributes.url} loading="lazy" width={92} alt="The Royal Canadian Air Cadets' logo." className="navbarlogo" />
        </Link>

        <nav role="navigation" className="navmenu w-nav-menu">
          {/* Display of Nav Links */}
          {navData.links &&
            navData.links.map((item) => {
              // Determine if the item will be a dropdown or not.
              return item.subLinks && item.subLinks.length > 0 ? navbardropdown(item) : navbarlink(item);
            })}

          {/* Resources */}
          <div data-hover="true" data-delay={0} className="w-dropdown">
            <div className="navbardropdown w-dropdown-toggle">
              <div className="w-icon-dropdown-toggle" />
              <Link key={uuid()} to="/resources" className="navlink w-nav-link">
                Resources
              </Link>
            </div>
            <nav className="navbardropdownlist w-dropdown-list">{renderCollection(CollectionEntry, collectionData, collectionSlug)}</nav>
          </div>

          {/* Login/Logout/Profile Links */}
          <LoginLogoutButton />

          {/* Highlighted Links */}
          {navData.linksHighlight &&
            navData.linksHighlight.map((item) => {
              if (item.slug === "/sign-up" && user) return null;
              return (
                <Link key={uuid()} to={item.slug} className="navlink navblue w-nav-link">
                  {item.text}
                </Link>
              );
            })}
        </nav>
        <div className="menubutton w-nav-button">
          <div className="icon w-icon-nav-menu" />
        </div>
      </div>
    </div>
  );

  function navbarlink(item) {
    return (
      <Link key={uuid()} to={item.slug} className="navlink w-nav-link">
        {item.text}
      </Link>
    );
  }

  function navbardropdown(item) {
    return (
      <div data-hover="true" data-delay={0} className="w-dropdown">
        <div className="navbardropdown w-dropdown-toggle">
          <div className="w-icon-dropdown-toggle" />
          <Link key={uuid()} to={item.slug} className="navlink w-nav-link">
            {item.text}
          </Link>
        </div>
        <nav className="navbardropdownlist w-dropdown-list">
          {item.subLinks &&
            item.subLinks.map((subItem) => {
              return navbardropdownlink(subItem);
            })}
        </nav>
      </div>
    );
  }
}

function navbardropdownlink(subItem) {
  return (
    <Link key={uuid()} to={subItem.slug} className="navlinkdropdown w-dropdown-link">
      {subItem.text}
    </Link>
  );
}

// Render select resources under the drop down.
const CollectionEntry = (props) => {
  let data = usePullData(props);

  return (
    <Link key={uuid()} to={`/resources/${props.id}`} className="navlinkdropdown w-dropdown-link">
      {data.title}
    </Link>
  );
};
export default Navbar;
